import { Checkbox, Textarea } from "@components";
import { BaseCurrencyInput } from "@components/CurrencyInput/BaseCurrencyInput";
import { useEffect, useState } from "react";
import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStep.module.scss";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Message } from "../../../components/Message";
import { If } from "../../../components/control-statements";
import { Icon } from "../../../components/core/Icon";
import { Select } from "@components";
import { Environment } from "shared/core/Environment";
import { BenefitImage } from "./BenefitImage";

import classNames from "classnames/bind";
import { UserStorage } from "shared/tools/UserStorage";
import dayjs from "dayjs";
const css = classNames.bind(styles);

export const BenefitInsertCodeStep = ({
  benefit,
  partners = [],
  onChange,
  programByPoint,
  benefitToEdit,
}) => {
  const [sku, setSku] = useState("");

  const isPercentage =
    ["PERCENTAGE_DISCOUNT", "CASHBACK", "PRODUCT_DISCOUNT"].indexOf(
      benefit.type,
    ) > -1;

  const addSKU = () => {
    const index = (benefit.product_list || []).indexOf(sku);

    if (index !== -1 || sku.length === 0) return;

    onChange &&
      onChange({
        ...benefit,
        product_list: [...(benefit.product_list || []), sku],
      });

    setSku("");
  };

  useEffect(() => {
    if (benefit.product_list?.length <= 1 && benefit.multiple_items === true)
      onChange && onChange({ ...benefit, multiple_items: false });

    if (benefit.expiration_days && benefit.expiration_type !== "DAYS") {
      onChange &&
        onChange({
          ...benefit,
          expiration_type: "DAYS",
        });
    }

    if (benefit.expiration_date && benefit.expiration_type !== "DATE") {
      onChange &&
        onChange({
          ...benefit,
          expiration_type: "DATE",
        });
    }
  }, [benefit, onChange]);

  return (
    <>
      <div className={styles.box}>
        <div className="d-flex align-stretch gap-15">
          <BenefitImage
            image={benefit.image}
            onChange={(image) => {
              onChange && onChange({ ...benefit, image });
            }}
          />
          <div className="d-flex flex-column w-100">
            <Label text="Descrição do benefício" />
            <Textarea
              value={benefit.description}
              onChange={(e) => {
                onChange &&
                  onChange({ ...benefit, description: e.target.value });
              }}
              max={150}
              maxLength={150}
            />
          </div>
        </div>
      </div>

      <If cond={!benefitToEdit}>
        <div className={styles.box}>
          <Label text="Insira o código do benefício" />
          <Input
            design="two"
            value={benefit.code}
            onChange={(text) =>
              onChange &&
              onChange({
                ...benefit,
                code: (text.target.value || "")
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/gi, ""),
              })
            }
            max={15}
          />

          <If cond={benefit.code?.length == 15}>
            <Message className="mt-10">Limite de 15 caracteres</Message>
          </If>
        </div>
      </If>

      <div className={styles.box}>
        <If cond={!benefitToEdit}>
          <Label text="Insira o valor e o pedido mínimo" />
        </If>
        <If cond={benefitToEdit}>
          <Label text="Insira o pedido mínimo" />
        </If>
        <Hairline className="mt-15 mb-10" />
        <div className="d-flex w-100">
          <If cond={benefit.type != "FREE_DELIVERY"}>
            <If
              cond={
                (benefit.type == "CASHBACK" && !programByPoint) ||
                benefit.type != "CASHBACK"
              }
            >
              <If cond={!benefitToEdit}>
                <BaseCurrencyInput
                  design="two"
                  label="Valor do beneficio"
                  className="w-100 mr-15 mb-0"
                  value={benefit.value}
                  prefix={isPercentage ? "" : "R$ "}
                  suffix={isPercentage ? " %" : ""}
                  precision={isPercentage ? 0 : 2}
                  onChange={(v) =>
                    onChange && onChange({ ...benefit, value: v })
                  }
                />
              </If>
              <BaseCurrencyInput
                design="two"
                label="Pedido mínimo"
                className="w-100 mb-0"
                value={benefit.min_order}
                onChange={(v) => {
                  onChange && onChange({ ...benefit, min_order: v });
                }}
              />
            </If>
            <If cond={programByPoint && benefit.type == "CASHBACK"}>
              <div className="d-flex flex-column w-100">
                <If cond={!benefitToEdit}>
                  <div className="d-flex align-center mb-15 mt-10">
                    <BaseCurrencyInput
                      design="two"
                      className="w-100 mb-0 pt-0"
                      suffix={" gastos"}
                      value={100}
                      disabled
                    />
                    <span className={styles.equal}>=</span>
                    <BaseCurrencyInput
                      design="two"
                      suffix={` ${benefit.value === 1 ? "ponto" : "pontos"}`}
                      prefix={""}
                      precision={0}
                      className="w-100 mb-0 pt-0"
                      value={benefit.value || 0}
                      onChange={(percentage) => {
                        onChange &&
                          onChange({
                            ...benefit,
                            value: percentage,
                          });
                      }}
                    />
                  </div>
                </If>
                <BaseCurrencyInput
                  design="two"
                  label="Pedido mínimo"
                  className="w-100 mb-0"
                  value={benefit.min_order}
                  onChange={(v) => {
                    onChange && onChange({ ...benefit, min_order: v });
                  }}
                />
              </div>
            </If>
          </If>
          <If cond={benefit.type == "FREE_DELIVERY"}>
            <BaseCurrencyInput
              design="two"
              label="Pedido mínimo"
              className="w-100 mb-0"
              value={benefit.min_order}
              onChange={(v) => {
                onChange && onChange({ ...benefit, min_order: v });
              }}
            />
          </If>
        </div>
      </div>

      <If
        cond={["PRODUCT_CASH_DISCOUNT", "PRODUCT_DISCOUNT"].includes(
          benefit.type,
        )}
      >
        <div className={styles.box}>
          <Label text="Adicione SKU's" />
          <Input value={sku} onChange={(e) => setSku(e.target.value)} />
          <Button
            onClick={addSKU}
            className="w-100 mt-20 mb-20"
            disabled={!sku}
          >
            Adicionar
          </Button>

          <Label text={`SKU's (${(benefit.product_list || []).length})`} />
          <div className={styles.skus}>
            {(benefit.product_list || []).length > 0 ? (
              (benefit.product_list || []).map((sku) => {
                return (
                  <div className={styles.sku} key={sku}>
                    <p>{sku}</p>
                    <div
                      className={styles.remove}
                      onClick={() =>
                        onChange &&
                        onChange({
                          ...benefit,
                          product_list: (benefit.product_list || []).filter(
                            (s) => s !== sku
                          ),
                        })
                      }
                    >
                      <i className="far fa-times" />
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={styles.emptySKUS}>
                <div className={styles.icon}>
                  <Icon name="fa-soup" light />
                </div>
                <p>Nenhum sku foi adicionado</p>
              </div>
            )}
          </div>
          <If cond={(benefit.product_list || []).length > 1}>
            <Checkbox
              className="mt-15 mb-15"
              checked={benefit.multiple_items}
              onChange={() => {
                onChange &&
                  onChange({
                    ...benefit,
                    multiple_items: !benefit.multiple_items,
                  });
              }}
            >
              Permitir múltiplos subitens?
            </Checkbox>
            {!benefit.multiple_items ? (
              <Message text="O cupom será liberado para uso somente quando um único SKU selecionado no produto esteja dentro dos subitems liberados no cupom, aplicando desconto em todas as unidades do subitem, mas somente em uma unidade do produto." />
            ) : (
              <Message text="O cupom será liberado para uso quando um ou mais SKU's selecionados no produto estejam dentro dos subitems liberados no cupom, aplicando desconto em todas as unidades do subitem, mas somente em uma unidade do produto." />
            )}
          </If>
        </div>
      </If>

      <If cond={!benefitToEdit}>
        <div className={styles.box}>
          <If
            cond={
              !benefit.expiration_type &&
              !benefit.expiration_days &&
              !benefit.expiration_date
            }
          >
            <Label text="Defina a expiração do benefício" />
          </If>
          <If
            cond={
              !!benefit.expiration_type ||
              !!benefit.expiration_days ||
              !!benefit.expiration_date
            }
          >
            <div className="d-flex align-center justify-between">
              <div className="d-flex flex-column">
                <If
                  cond={
                    benefit.expiration_type === "DAYS" ||
                    benefit.expiration_days
                  }
                >
                  <Label
                    text="Expiração a partir da contemplação"
                    className="mb-5"
                  />
                  <p className={styles.subtitle}>
                    A expiração deste benefício iniciar a partir do momento que
                    o usuário o recebe.
                  </p>
                </If>
                <If
                  cond={
                    benefit.expiration_type === "DATE" ||
                    benefit.expiration_date
                  }
                >
                  <Label text="Expiração em data fixa" className="mb-5" />
                  <p className={styles.subtitle}>
                    Determine qual será o último dia em que os usuários
                    utilizarão este benefício.
                  </p>
                </If>
              </div>
              <Button
                design="underline"
                onClick={() => {
                  onChange &&
                    onChange({
                      ...benefit,
                      expiration_type: null,
                      expiration_date: null,
                      spend_date: null,
                      expiration_days: null,
                      spend_days: null,
                    });
                }}
              >
                Desfazer
              </Button>
            </div>
          </If>

          <If cond={!benefit.expiration_type}>
            <div className={styles.options}>
              <div
                className={css({
                  option: true,
                  selected:
                    benefit.expiration_type === "DAYS" ||
                    !!benefit.expiration_days,
                })}
                onClick={() => {
                  onChange &&
                    onChange({
                      ...benefit,
                      expiration_type: "DAYS",
                      expiration_date: null,
                      spend_date: null,
                      expiration_days: null,
                      spend_days: null,
                    });
                }}
              >
                <div className={styles.icon}>
                  <i className="fal fa-circle-1" />
                </div>
                <p>Expiração a partir da contemplação</p>
              </div>
              <If cond={UserStorage.isGodMode}>
                <div
                  className={css({
                    option: true,
                    selected:
                      benefit.expiration_type === "DATE" ||
                      !!benefit.expiration_date,
                  })}
                  onClick={() => {
                    onChange &&
                      onChange({
                        ...benefit,
                        expiration_type: "DATE",
                        expiration_date: null,
                        spend_date: null,
                        expiration_days: null,
                        spend_days: null,
                      });
                  }}
                >
                  <div className={styles.icon}>
                    <i className="fal fa-calendar-day" />
                  </div>
                  <p>Expiração em data fixa</p>
                </div>
              </If>
            </div>
          </If>

          <If cond={benefit.expiration_type === "DAYS"}>
            <BaseCurrencyInput
              design="two"
              prefix={""}
              precision={0}
              className="mt-10 mb-0"
              value={benefit.expiration_days}
              onChange={(v) => {
                onChange &&
                  onChange({
                    ...benefit,
                    expiration_days: v,
                  });
              }}
              suffix={
                benefit.type === "CASHBACK"
                  ? " dias de expiração de ganho"
                  : " dias"
              }
            />
            <If cond={benefit.type === "CASHBACK"}>
              <BaseCurrencyInput
                design="two"
                prefix={""}
                precision={0}
                className="mb-0"
                value={benefit.spend_days}
                onChange={(v) => {
                  onChange &&
                    onChange({
                      ...benefit,
                      spend_days: v,
                    });
                }}
                suffix={" dias de expiração de gasto"}
              />
            </If>
          </If>
          <If cond={benefit.expiration_type === "DATE"}>
            <Input
              design="two"
              className="mt-20 mb-0"
              value={benefit?.expiration_date}
              mask="99/99/9999"
              placeholder="DD / MM / AAAA"
              type="tel"
              onChange={(e) => {
                onChange &&
                  onChange({
                    ...benefit,
                    expiration_date: e.target.value,
                  });
              }}
            />
            <If cond={benefit.type === "CASHBACK"}>
              <div className="mt-20">
                <p className={styles.subtitle}>
                  Determine a data de expiração do cashback gerado.
                </p>
                <Input
                  design="two"
                  className="mt-15 mb-0"
                  value={benefit?.spend_date}
                  mask="99/99/9999"
                  placeholder="DD / MM / AAAA"
                  type="tel"
                  onChange={(e) => {
                    onChange &&
                      onChange({
                        ...benefit,
                        spend_date: e.target.value,
                      });
                  }}
                />
              </div>
            </If>
          </If>
        </div>
      </If>

      <If cond={partners.length > 0}>
        <div className={styles.box}>
          <Label text={"Convênio"} />
          <Select
            value={benefit.partner_id}
            options={[
              { label: "Nenhum", value: null },
              ...partners.map((p) => ({ label: p.name, value: p.id })),
            ]}
            onChange={(e) => {
              onChange &&
                onChange({
                  ...benefit,
                  partner_id: e.target.value,
                });
            }}
          />
        </div>
      </If>

      <If cond={Environment.id === 34}>
        <div className={styles.box}>
          <Input
            design="two"
            className="mb-10"
            label="Grupo (3SCheckout)"
            value={benefit.group}
            onChange={(e) => {
              onChange &&
                onChange({
                  ...benefit,
                  group: e.target.value,
                });
            }}
          />
          <Input
            design="two"
            label="Justificativa (3SCheckout)"
            value={benefit.justification}
            onChange={(e) => {
              onChange &&
                onChange({
                  ...benefit,
                  justification: e.target.value,
                });
            }}
          />
        </div>
      </If>
    </>
  );
};
